import { ChatingProps } from '../components/Modals/DashboardModal/dashboardModalInterface';
import ExportFormat from '../utils/enum/ExportFormat';
import generateHeaders from './myHeaders';

const getChatConversation = async (surveyId: string, questionLabel: string, dateFilter: string, filter: string, conversation: Array<ChatingProps>, summary: string | undefined, exportType: ExportFormat, surveyName?: string, dashboardName?: string, selectedSchema?: string) => {
    const getFileExtension = (outFormat: ExportFormat) => {
        switch (outFormat) {
            case ExportFormat.WORD:
                return '.docx';
            default:
                return exportType.toLowerCase();
        }
    };

    const body = {
        dateFilter,
        filter,
        conversation,
        summary,
        exportType,
        questionLabel,
        dashboardName,
    };

    const requestOptions = {
        method: 'POST',
        headers: generateHeaders(selectedSchema),
        body: JSON.stringify(body),
    };

    const url = `${process.env.REACT_APP_API_URL}/survey/${surveyId}/answers/download_chat/`;

    try {
        const response = await fetch(url, requestOptions);
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        // Get the CSV data as a blob
        const blob = await response.blob();

        // Create a temporary URL for the blob
        const downloadUrl = window.URL.createObjectURL(blob);

        // Create a temporary anchor element and trigger the download
        const link = document.createElement('a');
        link.href = downloadUrl;

        // Generate filename with current timestamp
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        const seconds = String(now.getSeconds()).padStart(2, '0');

        const filename = `Korteo${surveyName ? ` - ${surveyName}` : ''}${dashboardName ? ` - ${dashboardName}` : ''} - Export Chat - ${year}-${month}-${day} ${hours}-${minutes}-${seconds}.${getFileExtension(exportType)}`;

        link.download = filename;

        // Append to body, click, and remove
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // Clean up the temporary URL
        window.URL.revokeObjectURL(downloadUrl);

        return { success: true, message: 'Download started' };
    } catch (err) {
        console.error(`Error downloading ${exportType}:`, err);

        return { success: false, error: err };
    }
};

export default getChatConversation;
